import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    messageRow: {
        paddingHorizontal: 12,
        marginVertical: 4,
    },
    systemRow: {
        paddingHorizontal: 12,
        marginVertical: 8,
    },
    contentRow: {
        flexDirection: 'row',
        alignItems: 'flex-end',
    },
    avatarLeft: {
        marginRight: 8,
    },
    avatarRight: {
        marginLeft: 8,
    },
    contentArea: {
        flex: 1,
        alignItems: 'flex-start',
    },
    contentAreaRight: {
        alignItems: 'flex-end',
    },
    contentAreaFullWidth: {
        flex: 1,
        maxWidth: '100%', // 头像隐藏时内容区占满宽度
    },
    senderName: {
        fontSize: 12,
        color: '#999999',
        marginBottom: 4,
        marginLeft: 4,
    },
    senderNameRight: {
        marginLeft: 0,
        marginRight: 4,
    },
    statusIconRight: {
        marginLeft: 6,
        marginRight: 0,
        justifyContent: 'flex-end',
        paddingBottom: 2,
    },
});
